import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-acid-conc-guage',
  templateUrl: './acid-conc-guage.component.html',
  styleUrl: './acid-conc-guage.component.css'
})
export class AcidConcGuageComponent {


  @Input()
  gaugeValue: any =40;

  @Input()
  gaugeLabel = "";

  @Input()
  gaugeAppendText = "";

  @Input()
  min=0

  @Input()
  max=100

  @Input()
  thresholds={}

  thresholdConfig = {
    '0': {color: 'green'},
    '30': {color: 'orange'},
    '40': {color: 'red'}
};


}
